@if (donationItems) {
  <div class="preview-item" [class.margin-0]="!label">
    @if (label) {
      <label>{{ label }}</label>
    }
    <p>{{ donationItems }}</p>
  </div>
}
